import React from "react";
import { Link } from "react-router-dom";
import styles from "./FooterItems2.module.css";

export const FooterItemsRow2 = ({ sections }) => {
  return (
    <ul className={styles.footer_last_row_items}>
      {sections.map((item) => (
        <li key={item.label}>
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : item.href ? (
            <a href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a>
          ) : (
            item.label
          )}
        </li>
      ))}
    </ul>
  );
};
